import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const fetchNewsArticles = createAsyncThunk(
    '/api/newsManagement/get',
    (args, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/newsManagement`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchNewsArticle = createAsyncThunk(
    '/api/newsManagement/newsArticleId',
    (newsArticleId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/newsManagement/${newsArticleId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postNewsArticle = createAsyncThunk(
    '/api/newsManagement/post',
    (newNewsArticle, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/newsManagement`, method: 'POST', body: newNewsArticle }, rejectWithValue)
);

export const putNewsArticle = createAsyncThunk(
    '/api/newsManagement/put',
    (updatedNewsArticle, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/newsManagement`, method: 'PUT', body: updatedNewsArticle }, rejectWithValue)
);

export const deleteNewsArticle = createAsyncThunk(
    '/api/newsManagement/delete/newsArticleId',
    (newsArticleId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/newsManagement/${newsArticleId}`, method: 'DELETE' }, rejectWithValue)
);

export const newsManagementSlice = createSlice({
    name: 'newsManagement',
    initialState: {
        newsArticles: { data: null, status: null },
        newsArticle: { data: null, status: null },
        newsArticlePost: { data: null, status: null },
        newsArticlePut: { data: null, status: null },
        newsArticleDelete: { data: null, status: null },
    },
    reducers: {
        resetNewsArticle: (state) => {
            ResetSliceState(state, [
                'newsArticle'
            ]);
        },
        resetNewsArticleManagementStatus: (state) => {
            ResetSliceState(state, [
                'newsArticlePost',
                'newsArticlePut',
                'newsArticleDelete'
            ]);
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchNewsArticles, 'newsArticles');
        CreateAsyncStatusHandler(builder, fetchNewsArticle, 'newsArticle');
        CreateAsyncStatusHandler(builder, postNewsArticle, 'newsArticlePost');
        CreateAsyncStatusHandler(builder, putNewsArticle, 'newsArticlePut');
        CreateAsyncStatusHandler(builder, deleteNewsArticle, 'newsArticleDelete');
    }
});

export const {
    resetNewsArticle,
    resetNewsArticleManagementStatus
} = newsManagementSlice.actions;

export default newsManagementSlice.reducer;